import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { SnowAreaEditViewModel } from '../models/SnowAreaEditViewModel';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class SnowAreaService {
  private url = '/api/snowArea/';
  constructor(private http: HttpClient) { }
  get(id: number): Observable<any> {
    return this.http.get<any>(this.url + `get?id=${id}`, httpOptions)
      .pipe(catchError(error => { return throwError(error) }));
  }
  getUpdate(id: number): Observable<SnowAreaEditViewModel> {
    return this.http.get<SnowAreaEditViewModel>(this.url + `update?id=${id}`, httpOptions)
      .pipe(catchError(error => { return throwError(error) }));
  }
  save(something: SnowAreaEditViewModel): Observable<any> {
    return this.http.post<SnowAreaEditViewModel>(this.url + 'create', something, httpOptions)
      .pipe(catchError(error => { return throwError(error) }));
  }
  update(something: SnowAreaEditViewModel): Observable<any> {
    return this.http.put<SnowAreaEditViewModel>(this.url + 'update', something, httpOptions)
      .pipe(catchError(error => { return throwError(error) }));
  }
  delete(id: number): Observable<any> {
    return this.http.delete<any>(this.url + `delete?id=${id}`, httpOptions)
      .pipe(catchError(error => { return throwError(error) }));
  }
}
